import { Elements } from "@stripe/react-stripe-js";
import { CheckoutForm } from "./CheckoutForm";

function StripeForm(props) {
  const {
    clientSecret,
    stripePromise,
    groupName,
    groupData,
    setShowPaymentForm,
    selectedPlan,
  } = props;

  const options = {
    // passing the client secret obtained from the server
    clientSecret,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm
        selectedPlan={selectedPlan}
        groupName={groupName}
        groupData={groupData}
        setShowPaymentForm={setShowPaymentForm}
      />
    </Elements>
  );
}

export default StripeForm;
